'use client';

import { Button } from '@zillow/constellation-10';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { usePathname } from '@/src/i18n/navigation';
import AppleGlyph from '@/src/components/ui/icons/AppleGlyph';
import { replaceOnSameTabClick } from '@/src/lib/auth/provider-navigation';
import { useAppleAuth } from './useAppleAuth';

type AppleSignInButtonProps = {
  postLoginRedirect?: string;
};

export function AppleSignInButton({ postLoginRedirect }: AppleSignInButtonProps) {
  useAppleAuth();
  const t = useTranslations('auth');
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString();
  const currentPath = search ? `${pathname}?${search}` : pathname;
  const startUrl = `/api/auth/apple/start?redirect=${encodeURIComponent(postLoginRedirect ?? currentPath)}`;

  return (
    <Button asChild tone="neutral" emphasis="outlined" size="lg" fluid icon={<AppleGlyph />}>
      <a href={startUrl} onClick={(event) => replaceOnSameTabClick(event, startUrl, pathname)}>
        {t('continueWithApple')}
      </a>
    </Button>
  );
}
